// This file is part of Invenio-RDM-Records
// Copyright (C) 2020-2024 CERN.
// Copyright (C) 2020-2022 Northwestern University.
// Copyright (C) 2021 Graz University of Technology.
//
// Invenio-RDM-Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

// Overrides to remove the selection of the subjects scheme

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  GroupField,
  SubjectAutocompleteDropdown,
} from "react-invenio-forms";
import { i18next } from "@translations/invenio_rdm_records/i18next";

export class SubjectsField extends Component {
  state = {
    limitTo: "all",
  };
  render() {
    const { fieldPath, label, labelIcon, limitToOptions, ...dropdownProps } =
      this.props;
    const { limitTo } = this.state;
    return (
      <>
      <GroupField className="main-group-field">
        <SubjectAutocompleteDropdown
          {...dropdownProps}
          fieldPath={fieldPath}
          limitTo={limitTo}
          width={11}
        />
      </GroupField>
      </>
    );
  }
}

SubjectsField.propTypes = {
  limitToOptions: PropTypes.array.isRequired,
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  placeholder: PropTypes.string,
};

SubjectsField.defaultProps = {
  label: i18next.t("Keywords and subjects"),
  labelIcon: "tag",
  placeholder: i18next.t("Search for a subject by name"),
};
